import React, { useState, useEffect } from 'react';

interface SimplePhoneInputProps {
    placeholder?: string;
    error?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    className?: string;
    value?: string;
}

export const SimplePhoneInput: React.FC<SimplePhoneInputProps> = ({
    placeholder = "747 630 2586",
    error,
    onChange,
    disabled = false,
    className = '',
    value: externalValue = '',
}) => {
    const [value, setValue] = useState(externalValue);

    // Синхронизация внешнего значения с внутренним состоянием
    useEffect(() => {
        setValue(externalValue);
    }, [externalValue]);

    const formatPhone = (input: string) => {
        // Удаляем все нецифровые символы
        const digits = input.replace(/\D/g, '');

        // Форматируем как XXX XXX XXXX
        if (digits.length <= 3) {
            return digits;
        } else if (digits.length <= 6) {
            return `${digits.slice(0, 3)} ${digits.slice(3)}`;
        } else {
            return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const formattedValue = formatPhone(inputValue);

        setValue(formattedValue);

        // Создаем событие с отформатированным значением
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                value: formattedValue
            }
        };

        onChange?.(syntheticEvent);
    };

    return (
        <input
            type="tel"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            placeholder={placeholder}
            className={className}
            maxLength={12} // XXX XXX XXXX = 12 символов
        />
    );
};
